import { Box, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

const Content = styled(Box)({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

const Inner = styled(Box)({
  width: '100%',
  height: '100%',
  flex: 1,
  minHeight: 0,
});

const ActionBar = styled(Box)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.md, theme.spacingSizes.lg),
  borderTop: `1px solid ${theme.palette.borderColor.main}`,
  position: 'sticky',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: theme.palette.background.paper,
  margin: theme.spacing(
    0,
    -theme.spacingSizes.xl,
    -theme.spacingSizes.xl,
    -theme.spacingSizes.xl,
  ),
  zIndex: theme.zIndex.appBar,
}));

const FullHeightView: React.FC<
  PropsWithChildren<{ actionBar?: React.ReactNode }>
> = ({ children, actionBar }) => {
  return (
    <Content>
      <Inner>{children}</Inner>
      {actionBar ? <ActionBar>{actionBar}</ActionBar> : null}
    </Content>
  );
};

export default FullHeightView;
